import React, { useEffect, useState } from "react";
import { fetchCustomizedTrips } from "../services/Customizedtripslistfilter";
import { API_BASE } from "../api/apiConfig";

const Customizedtripslist = () => {
  const [activeTab, setActiveTab] = useState("international");

  const [trips, setTrips] = useState([]);
  const [filteredTrips, setFilteredTrips] = useState([]);

  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState("All Countries");
  const [selectedCity, setSelectedCity] = useState("All Cities");

  const [loading, setLoading] = useState(true);

  const [visibleCount, setVisibleCount] = useState(6);
  const visibleTrips = filteredTrips.slice(0, visibleCount);

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    loadTrips();
  }, []);

  const loadTrips = async (type = "international") => {
  const res = await fetchCustomizedTrips(type);
  if (res?.status) {
    setTrips(res.data);
    setFilteredTrips(res.data);

    setCountries([
      ...new Set(res.data.map(t => t.country_name).filter(Boolean)),
    ]);

    setCities([
      ...new Set(res.data.map(t => t.city).filter(Boolean)),
    ]);
  }
  setLoading(false);
};

useEffect(() => {
  loadTrips(activeTab);
}, [activeTab]);

  /* ================= FILTER LOGIC ================= */
  useEffect(() => {
    if (activeTab === "international") {
      setFilteredTrips(
        selectedCountry === "All Countries"
          ? trips
          : trips.filter(t => t.country_name === selectedCountry)
      );
    } else {
      setFilteredTrips(
        selectedCity === "All Cities"
          ? trips
          : trips.filter(t => t.city === selectedCity)
      );
    }
  }, [activeTab, selectedCountry, selectedCity, trips]);

  const activeTabLabel =
    activeTab === "international" ? "International" : "Domestic";

  if (loading) {
    return <p className="text-center py-10">Loading trips...</p>;
  }

  /* ================= UI ================= */
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">

        {/* TITLE */}
       <div className="text-center mb-4">
          <div className="border transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 mb-3 inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-star mr-1 h-4 w-4"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg> Inspiration
          </div>
          <h2 className="text-3xl font-bold text-slate-900 mb-4">Explore Customized Trips</h2>
          <p className="text-slate-600 max-w-2xl mx-auto mb-8">
            Browse our curated collection organized by destination. Each trip is fully customizable to your preferences.
          </p>
        </div>

        {/* TAB TOGGLE */}
        <div className="flex justify-center mb-6">
          <div className="flex justify-center mb-6">
  <div className="bg-slate-50 rounded-2xl p-2 inline-flex gap-2 shadow-sm border border-slate-200">

    {/* International Button */}
    <button
      onClick={() => {
        setActiveTab("international");
        setSelectedCity("All Cities");
      }}
      className={`inline-flex items-center justify-center whitespace-nowrap text-sm 
      h-11 rounded-xl px-6 font-semibold transition-all duration-200
      ${
        activeTab === "international"
          ? "bg-gradient-to-r from-primary to-purple-600 text-white shadow-md"
          : "text-slate-700 hover:text-slate-900 hover:bg-accent"
      }`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="mr-2 h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
        <path d="M2 12h20" />
      </svg>
      International
    </button>

    {/* Domestic Button */}
    <button
      onClick={() => {
        setActiveTab("domestic");
        setSelectedCountry("All Countries");
      }}
      className={`inline-flex items-center justify-center whitespace-nowrap text-sm 
      h-11 rounded-xl px-6 font-semibold transition-all duration-200
      ${
        activeTab === "domestic"
          ? "bg-gradient-to-r from-primary to-purple-600 text-white shadow-md"
          : "text-slate-700 hover:text-slate-900 hover:bg-accent"
      }`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="mr-2 h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
      Domestic
    </button>

  </div>
</div>
        </div>

        {/* FILTERS */}
        {activeTab === "international" && (
          <div className="mb-8 text-center">
            <p className="text-sm font-semibold text-slate-700 mb-3 flex items-center justify-center gap-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe h-4 w-4 text-primary"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path></svg> Filter by Country</p>
            <div className="flex flex-wrap justify-center gap-2">
              <button
                onClick={() => setSelectedCountry("All Countries")}
                className={`px-5 h-9 rounded-full ${
                  selectedCountry === "All Countries"
                    ? "bg-primary text-white"
                    : "border"
                }`}
              >
                All Countries
              </button>

              {countries.map(country => (
                <button
                  key={country}
                  onClick={() => setSelectedCountry(country)}
                  className={`px-5 h-9 rounded-full ${
                    selectedCountry === country
                      ? "bg-primary text-white"
                      : "border"
                  }`}
                >
                  {country}
                </button>
              ))}
            </div>
          </div>
        )}

        {activeTab === "domestic" && (
          <div className="mb-8 text-center">
            <p className="text-sm font-semibold text-slate-700 mb-3 flex items-center justify-center gap-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe h-4 w-4 text-primary"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path></svg> Filter by City</p>
            <div className="flex flex-wrap justify-center gap-2">
              <button
                onClick={() => setSelectedCity("All Cities")}
                className={`px-5 h-9 rounded-full ${
                  selectedCity === "All Cities"
                    ? "bg-primary text-white"
                    : "border"
                }`}
              >
                All Cities
              </button>

              {cities.map(city => (
                <button
                  key={city}
                  onClick={() => setSelectedCity(city)}
                  className={`px-5 h-9 rounded-full ${
                    selectedCity === city
                      ? "bg-primary text-white"
                      : "border"
                  }`}
                >
                  {city}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* COUNT */}
        <p className="text-center mb-8 text-slate-600">
          Showing{" "}
          <span className="text-primary font-semibold">
            {filteredTrips.length}
          </span>{" "}
          trips
        </p>

        {/* TRIP CARDS */}
         <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {filteredTrips.map((trip) => (
           <a className="block" href={`/CustomizedTripsDtl/${activeTab === "international" ? 1 : 2}/${trip.id}`}>
            <div key={trip.id} className="rounded-lg border bg-card group overflow-hidden border-slate-200 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={
                    trip.images
                      ? `${API_BASE}${trip.images}`
                      : `${API_BASE}default.jpg`
                  }
                  alt={trip.name}
                  className="object-cover h-full w-full transition-transform duration-500 group-hover:scale-110"
                />
                {/* Badges */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute top-4 left-4 bg-white/95 text-slate-900 backdrop-blur-sm shadow-md">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe h-3 w-3 mr-1"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path></svg>
                  <span>
                    {activeTab === "international"}
                  </span>
                  <span className="font-semibold text-sm">
                    {activeTabLabel}
                  </span>
                </div>
                <div className="absolute top-4 right-4 bg-primary/90 text-white rounded-full px-2.5 py-0.5 text-xs font-semibold shadow-md">
                  {activeTab === "international" ? trip.country_name : trip.city}
                </div>
                {/* Trip Info */}
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 class="text-xl font-bold text-white mb-2 group-hover:text-primary/90 transition-colors">{trip.name}</h3>
                  <div class="flex items-center gap-4 text-sm text-white/95">
                    <div class="flex items-center gap-1.5">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-clock h-4 w-4"
                        >
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline></svg
                        ><span>{trip.no_of_days} Days</span>
                    </div>
                {trip.spots && Number(trip.spots) !== 0 && (
                    <div class="flex items-center gap-1.5">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-users h-4 w-4"
                        >
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg
                        ><span>{trip.spots} People</span>
                    </div>
                )}
                </div>
                </div>
              </div>
              {/* Card Content */}
              <div class="p-5">

            {trip.descriptions?.[0]?.activity && (
            (() => {
              const activities = trip.descriptions[0].activity
                .split("@@")
                .map(a => a.trim())
                .filter(Boolean)
                .slice(0, 3); // ✅ only 3

              return activities.length > 0 && (
                <div class="mb-4">
                    <p class="text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">Trip Highlights</p>
                    <ul class="space-y-1.5">
                    {activities.map((activitydata, index) => (
                        <li key={index} class="flex items-start gap-2 text-sm text-slate-600">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-check-circle h-4 w-4 text-primary flex-shrink-0 mt-0.5"
                            >
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <path d="m9 11 3 3L22 4"></path></svg
                            ><span>{activitydata}</span>
                        </li>
                    ))}

                    </ul>
                </div>
                 );
                  })()
                )}
                <div class="pt-4 border-t border-slate-100 space-y-3">
                    <div class="flex items-center justify-between">
                        <div>
                          {Number(trip.charges) !== 0 && (
                            <p class="text-xs text-slate-500 mb-0.5">Starting from</p>
                          )}
                            <p class="text-lg font-bold text-primary">{Number(trip.charges) === 0 ? "Customised" : `₹${trip.charges}`}</p>
                        </div>
                      {Number(trip.charges) !== 0 && (
                        <div
                            class="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-foreground text-xs"
                        >
                            Per Person
                        </div>
                      )}
                    </div>
                    <button
                            class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 h-10 px-4 py-2 w-full bg-gradient-to-r from-primary to-purple-600 hover:from-primary/90 hover:to-purple-600/90 text-white font-semibold shadow-md group"
                        >
                            View Details<svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-chevron-right ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform"
                            >
                                <path d="m9 18 6-6-6-6"></path>
                            </svg></button
                    >
                </div>
            </div>

            </div>
          </a>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Customizedtripslist;
